const e = "2.5.0-beta.1";
export {
  e as version
};
//# sourceMappingURL=version.js.map
